import {
  SET_ESG_COMPLIANCE_ASSESSMENT_DETAILS,
  SET_ESG_COMPLIANCE_STRUCTURED_REPORT_DATA,
  SET_ORIGINAL_ESG_COMPLIANCE_ASSESSMENT_DETAILS,
  SET_SELECTED_COMPLIANCE_ROW_DATA,
  SET_ESG_COMPLIANCE_FILTERED_REPORT_DATA,
  SET_ESG_COMPLIANCE_FILTERED_AUDIT_REPORT_DATA,
  SET_ESG_COMPLIANCE_STRUCTURED_AUDIT_REPORT_DATA,
  UPDATE_CHECKED_ITEMS,
  UPDATE_MAIN_TOPIC_ID,
  UPDATE_CONTRIBUTOR_IDS,
  UPDATE_APPROVER_IDS,
  UPDATE_FILTER_STATUS,
  UPDATE_SUB_SUB_SECTION_ID,
  CLEAR_ALL_FILTERS,
} from "constants/esgCompliance/esgSComplianceConst";
import apiBolerplate from "utils/_helpers/apiBolerplate";
import { reduxGet } from "utils/_helpers/reduxGet";
import { queryClient } from "index";

// ----------------- Payloads -----------------

export function setEsgComplianceAssessmentDetails(payload) {
  return {
    type: SET_ESG_COMPLIANCE_ASSESSMENT_DETAILS,
    payload: payload,
  };
}

export function setOriginalEsgComplianceDetails(payload) {
  return {
    type: SET_ORIGINAL_ESG_COMPLIANCE_ASSESSMENT_DETAILS,
    payload: payload,
  };
}

export const setSelectedComplianceRowData = (payload) => {
  reduxGet.dispatch({
    type: SET_SELECTED_COMPLIANCE_ROW_DATA,
    payload: payload,
  });
};

// Action creator to set ESG compliance structured report data
export const setEsgComplianceStructuredReportData = (payload) => {
  return {
    type: SET_ESG_COMPLIANCE_STRUCTURED_REPORT_DATA,
    payload: payload,
  };
};
export const setEsgComplianceFilteredReportData = (payload) => {
  return {
    type: SET_ESG_COMPLIANCE_FILTERED_REPORT_DATA,
    payload: payload,
  };
};
export const setEsgComplianceStructuredAuditReportData = (payload) => {
  return {
    type: SET_ESG_COMPLIANCE_STRUCTURED_AUDIT_REPORT_DATA,
    payload: payload,
  };
};
export const setEsgComplianceFilteredAuditReportData = (payload) => {
  return {
    type: SET_ESG_COMPLIANCE_FILTERED_AUDIT_REPORT_DATA,
    payload: payload,
  };
};

//for filter
export const updateCheckedItems = (fromReport, payload) => ({
  type: UPDATE_CHECKED_ITEMS,
  payload: { fromReport, payload },
});

export const updateMainTopicId = (fromReport, payload) => ({
  type: UPDATE_MAIN_TOPIC_ID,
  payload: { fromReport, payload },
});

export const updateSubSubSectionId = (fromReport, payload) => ({
  type: UPDATE_SUB_SUB_SECTION_ID,
  payload: { fromReport, payload },
});

export const updateFilterStatus = (fromReport, payload) => ({
  type: UPDATE_FILTER_STATUS,
  payload: { fromReport, payload },
});

// export const updateContributorIds = (formReport,payload) => ({

//   type: UPDATE_CONTRIBUTOR_IDS,
//   payload:{formReport,payload}
// });
// export const updateContributorIds = (formReport, payload) => {
//   console.log("Dispatching updateContributorIds:", { formReport, payload });

//   return {
//     type: UPDATE_CONTRIBUTOR_IDS,
//     payload: { formReport, payload },
//   };
// };
export const updateContributorIds = (fromReport, payload) => {
  return {
    type: UPDATE_CONTRIBUTOR_IDS,
    payload: { fromReport, payload },
  };
};

export const updateApproverIds = (fromReport, payload) => ({
  type: UPDATE_APPROVER_IDS,
  payload: { fromReport, payload },
});

export const clearAllFilters = (payload) => ({
  type: CLEAR_ALL_FILTERS,
  payload: payload,
});

// export const removeFilterChip = (chip) => (dispatch, getState) => {
//   console.log("chip at action",chip)
//   const state = getState();
//   const currentState = state.escCompliance;

//   if (chip.type === 'status') {
//     dispatch({
//       type: 'UPDATE_FILTER_STATUS',
//       payload: currentState.statusName.filter(status => status !== chip.id)
//     });
//   } if (chip.type === 'contributor') {
//     dispatch({
//       type: 'UPDATE_CONTRIBUTOR_IDS',
//       payload: currentState.contributorIds.filter(id => id !== chip.id)
//     });
//   } else if (chip.type === 'approver') {
//     dispatch({
//       type: 'UPDATE_APPROVER_IDS',
//       payload: currentState.approverIds.filter(id => id !== chip.id)
//     });
//   } else if (chip.type === 'section') {
//     console.log("under section in action")
//     console.log("in section chip main topic id",chip.mainTopicId)
//     const updatedMainTopicId = { ...currentState.mainTopicId };
//     if (updatedMainTopicId[chip.mainTopicId]) {
//       updatedMainTopicId[chip.mainTopicId] = updatedMainTopicId[chip.mainTopicId].filter(
//         id => id !== chip.id
//       );
//       if (updatedMainTopicId[chip.mainTopicId].length === 0) {
//         delete updatedMainTopicId[chip.mainTopicId];
//       }
//     }
//     dispatch({ type: 'UPDATE_MAIN_TOPIC_ID', payload: updatedMainTopicId });
//   } else if (chip.type === 'subsection') {
//     console.log("under subsection in action")
//     dispatch({
//       type: 'UPDATE_SUB_SUB_SECTION_ID',
//       payload: currentState.sub_SubSectionId.filter(id => id !== chip.id)
//     });
//   }

//   // Update checked items
//   const updatedCheckedItems = { ...currentState.checkedItems };
//   delete updatedCheckedItems[chip.id];
//   dispatch({ type: 'UPDATE_CHECKED_ITEMS', payload: updatedCheckedItems });

//   //  Get the latest updated state AFTER all dispatches
//   const updatedState = getState().escCompliance;

//   dispatch(getEsgComplianceFilteredReportData(
//     updatedState.esgComlianceAssessmentDetail?._id,
//     updatedState.esgComlianceAssessmentDetail?.framework_id,
//     updatedState.esgComlianceAssessmentDetail?.template_type,
//     0,
//     5000,
//     "",
//     Object.keys(updatedState.mainTopicId),
//     Object.values(updatedState.mainTopicId).flat(),
//     updatedState.sub_SubSectionId,
//     updatedState.statusName,
//     updatedState.contributorIds,
//     updatedState.approverIds
//   ));
// };

// ----------------- Actions -----------------
export const removeFilterChip = (chip, fromReport) => (dispatch, getState) => {
  const state = getState();
  const filterState = fromReport
    ? state.escCompliance.reportFilters
    : state.escCompliance.auditFilters;

  // Define updatedMainTopicId outside the switch to access it later
  let updatedMainTopicId = { ...filterState.mainTopicId };

  // Handle different filter types
  switch (chip.type) {
    case "status":
      dispatch(
        updateFilterStatus(
          fromReport,
          filterState.statusName.filter((status) => status !== chip.id)
        )
      );
      break;

    case "contributor":
      dispatch(
        updateContributorIds(
          fromReport,
          filterState.contributorIds.filter((id) => id !== chip.id)
        )
      );
      break;

    case "approver":
      dispatch(
        updateApproverIds(
          fromReport,
          filterState.approverIds.filter((id) => id !== chip.id)
        )
      );
      break;

    case "section":
      if (updatedMainTopicId[chip.mainTopicId]) {
        updatedMainTopicId[chip.mainTopicId] = updatedMainTopicId[
          chip.mainTopicId
        ].filter((id) => id !== chip.id);

        if (updatedMainTopicId[chip.mainTopicId].length === 0) {
          delete updatedMainTopicId[chip.mainTopicId];
        }
      }
      dispatch(updateMainTopicId(fromReport, updatedMainTopicId));
      break;

    case "subsection":
      dispatch(
        updateSubSubSectionId(
          fromReport,
          filterState.sub_SubSectionId.filter((id) => id !== chip.id)
        )
      );
      break;

    default:
      break;
  }

  // Update checked items
  const updatedCheckedItems = { ...filterState.checkedItems };
  delete updatedCheckedItems[chip.id];
  dispatch(updateCheckedItems(fromReport, updatedCheckedItems));

  // Prepare API parameters

  // Dispatch appropriate API call
  const updatedState = getState().escCompliance;
  if (fromReport) {
    // dispatch(
    //   getEsgComplianceFilteredReportData(
    //     updatedState.esgComlianceAssessmentDetail?._id,
    //     updatedState.esgComlianceAssessmentDetail?.framework_id,
    //     updatedState.esgComlianceAssessmentDetail?.template_type,
    //     0,
    //     5000,
    //     "",
    //     Object.keys(updatedState?.reportFilters?.mainTopicId),
    //     Object.values(updatedState?.reportFilters?.mainTopicId).flat(),
    //     updatedState?.reportFilters?.sub_SubSectionId,
    //     updatedState?.reportFilters?.statusName,
    //     updatedState?.reportFilters?.contributorIds,
    //     updatedState?.reportFilters.approverIds
    //   )
    // );
  } else {
    // dispatch(getEsgComplianceFilteredAuditReportData(params));
    dispatch(
      getEsgComplianceFilteredAuditReportData(
        updatedState.esgComlianceAssessmentDetail?._id,
        updatedState.esgComlianceAssessmentDetail?.framework_id,
        updatedState.esgComlianceAssessmentDetail?.template_type,
        0,
        5000,
        "",
        Object.keys(updatedState?.auditFilters?.mainTopicId),
        Object.values(updatedState?.auditFilters?.mainTopicId).flat(),
        updatedState?.auditFilters?.sub_SubSectionId,
        updatedState?.auditFilters?.statusName
        // updatedState.contributorIds,
        // updatedState.approverIds
      )
    );
  }
};

export async function getEsgComplianceAssessmentList(
  entity_id,
  limit,
  starting_after = 0,
  keyword
) {
  const data = await apiBolerplate({
    url: "/esg_compliance/get_esg_compliances",
    bodyData: { entity_id, limit, starting_after, keyword },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function createEsgComplianceAssessment(basicDetail) {
  const data = await apiBolerplate({
    url: "/esg_compliance/create_esg_compliances",
    bodyData: { ...basicDetail },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function getEsgComplianceAssessmentDetails(esg_compliance_id) {
  const data = await apiBolerplate({
    url: "/esg_compliance/get_esg_compliance_details",
    bodyData: { esg_compliance_id },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function updateEsgComplianceAssessment(basicDetail) {
  const data = await apiBolerplate({
    url: "/esg_compliance/update_esg_compliance_details",
    bodyData: {
      ...basicDetail,
      esg_compliance_id: basicDetail?._id,
    },
    hideLoader: true,
    // hideMsg: true,
    messageType: "success",
  });

  if (data?.status) {
    queryClient.invalidateQueries(["esgComplianceAssessmentList"]);
  }

  return data; // Return the data for further use
}

export async function getEsgComplianceReportData(
  esg_compliance_id,
  framework_id,
  template_type,
  starting_after,
  limit,
  keyword,
  selectedFilters
) {
  const data = await apiBolerplate({
    url: "/esg_compliance_new/compliance/get_assessment_progress",
    bodyData: {
      assessment_id: esg_compliance_id,
      framework_id,
      template_type,
      starting_after,
      limit,
      search: keyword,
      filters: selectedFilters,
    },
    hideLoader: true,
    hideMsg: true,
  });
  return data; // Return the data for further use
}

export async function getEsgComplianceReportWidgetsCounts(
  assessment_id,
  framework_id
) {
  const data = await apiBolerplate({
    url: "/esg_compliance_new/compliance/get_summary",
    bodyData: {
      assessment_id,
      framework_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function getEsgComplianceApproveWidgetsCounts(
  esg_compliance_id,
  framework_id
) {
  const data = await apiBolerplate({
    url: "/esg_compliance/get_status_summery_for_audit_approve_data",
    bodyData: {
      esg_compliance_id,
      framework_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function getEsgComplianceTopicStructuredData(
  framework_id,
  template_type,
  organization_id,
  esg_compliance_id
) {
  const data = await apiBolerplate({
    url: "/esg_compliance_new/assign/get_full_hierarchy",
    bodyData: {
      framework_id: framework_id,
      // template_type,
      // organization_id,
      assessment_id: esg_compliance_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function getEsgComplianceRecordMetricStructuredData({
  framework_id,
  template_type,
  esg_compliance_id,
  assign_for,
  organization_id,
}) {
  const data = await apiBolerplate({
    url: "/esg_compliance/get_recorded_metrics_hierarchy",
    bodyData: {
      framework_id,
      template_type,
      esg_compliance_id,
      assign_for,
      organization_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function assignComplianceReportData(assignDetails) {
  let url = window.origin;
  let domain_name = window.location.hostname;
  const data = await apiBolerplate({
    url: "/esg_compliance_new/assign/assign_users",
    bodyData: {
      ...assignDetails,
      url,
      domain_name,
    },
    hideLoader: false,
    hideMsg: false,
    messageType: "success",
  });

  return data; // Return the data for further use
}

export async function submitEsgComplianceMetricRecord(submission_data) {
  const data = await apiBolerplate({
    url: "/esg_compliance_new/compliance/record_data",
    bodyData: {
      ...submission_data,
    },
    hideLoader: true,
    files: { file: submission_data?.file },
    // hideMsg: true,
    messageType: "success",
  });

  return data; // Return the data for further use
}

export async function esgComplianceMetricGetProgress(
  esg_compliance_id,
  metric_id
) {
  const data = await apiBolerplate({
    url: "/esg_compliance/get_progress",
    bodyData: {
      esg_compliance_id,
      metric_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function esgComplianceMetricViewSubmissions(
  esg_compliance_id,
  metric_id
) {
  const data = await apiBolerplate({
    url: "/esg_compliance_new/compliance/get_submissions",
    bodyData: {
      assessment_id: esg_compliance_id,
      question_id: metric_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function esgComplianceMetricAuditApproveData(
  esg_compliance_id,
  framework_id,
  starting_after,
  limit,
  template_type,
  keyword
) {
  const data = await apiBolerplate({
    url: "/esg_compliance/view_audit_approve_data",
    bodyData: {
      esg_compliance_id,
      framework_id,
      starting_after,
      limit,
      template_type,
      keyword,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function getAuditors(param) {
  const data = await apiBolerplate({
    url: "/stakeholder/get_auditors",
    bodyData: {
      ...param,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function assignComplianceAuditorFinalApprover(assignDetails) {
  const data = await apiBolerplate({
    url: "/assign_stakeholder/assign_user_in_approve_and_audit",
    bodyData: {
      ...assignDetails,
    },
    hideLoader: true,
    hideMsg: false,
    messageType: "success",
  });

  return data; // Return the data for further use
}

export async function omitEsgComplianceReportDataMetric(omitDetails) {
  const data = await apiBolerplate({
    url: "esg_compliance_new/compliance/omit_question",
    bodyData: {
      ...omitDetails,
    },
    files: { file: omitDetails?.file },
    hideLoader: false,
    hideMsg: false,
    messageType: "info",
    customMessage:
      omitDetails?.url === "revert_omission" ? "Omission Reverted" : "Omitted",
  });

  return data; // Return the data for further use
}

export async function getEsgComplianceAuditReportLists(esg_compliance_id) {
  const data = await apiBolerplate({
    url: "/auditor/view_audited_reports ",
    bodyData: {
      esg_compliance_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function getSuatainabilityReportData({
  framework_id,
  esg_compliance_id,
  template_type,
  hasAudited,
}) {
  const data = await apiBolerplate({
    url: "/sustainability_report/get_suatainability_report_data",
    bodyData: {
      framework_id,
      esg_compliance_id,
      template_type,
      hasAudited,
    },
    hideLoader: true,
    hideMsg: true,
    messageType: "success",
  });

  return data; // Return the data for further use
}

export async function getSuatainabilityReportDataForDocument({
  framework_id,
  esg_compliance_id,
  template_type,
  hasAudited,
}) {
  const data = await apiBolerplate({
    url: "/esg_compliance_new/compliance/get_sustainability_report",
    bodyData: {
      framework_id,
      assessment_id: esg_compliance_id,
      template_type,
      hasAudited,
    },
    hideLoader: false,
    hideMsg: true,
  });
  return data; // Return the data for further use
}

export async function getSuatainabilityReportDataForXBRL({
  framework_id,
  esg_compliance_id,
  template_type,
  hasAudited,
}) {
  const data = await apiBolerplate({
    url: "/esg_compliance_new/compliance/get_sustainability_report_xbrl",
    bodyData: {
      framework_id,
      assessment_id: esg_compliance_id,
      template_type,
      hasAudited,
    },
    hideLoader: false,
    hideMsg: true,
  });
  return data; // Return the data for further use
}

export async function fetchComplianceDatasetRecord({
  esg_compliance_id,
  metric_id,
  disclosureId,
  disclosureName,
  organizationId,
  survey_type,
  sampleFormat,
}) {
  const data = await apiBolerplate({
    url: "/esg_compliance_gpt_chat/fetch_dataset_record",
    bodyData: {
      esg_compliance_id,
      metric_id,
      disclosureId,
      disclosureName,
      organizationId,
      survey_type,
      sampleFormat,
    },
    hideLoader: true,
    hideMsg: true,
    callback: (data) => {
      // data
    },
  });

  return data?.result;
}

export async function refetchComplianceRecordedData({
  esg_compliance_id,
  metric_id,
  disclosureId,
  disclosureName,
  organizationId,
  survey_type,
  sampleFormat,
}) {
  const data = await apiBolerplate({
    url: "/esg_compliance_gpt_chat/refetch_recorded_data",
    bodyData: {
      esg_compliance_id,
      metric_id,
      disclosureId,
      disclosureName,
      organizationId,
      survey_type,
      sampleFormat,
    },
    callback: (data) => {
      // data
    },
  });

  return data?.result;
}

export async function getEsgComplianceKpi({ esg_compliance_id, metric_id }) {
  const data = await apiBolerplate({
    url: "/esg_compliance/get_kpis",
    bodyData: {
      esg_compliance_id,
      metric_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

export async function getEsgComplianceLinkedKpi({
  framework_id,
  organization_id,
  question_id,
  keyword,
  starting_after = 0,
  limit = 15,
}) {
  const data = await apiBolerplate({
    url: "/datahub_linkages/linkages/get_linked_kpis",
    bodyData: {
      framework_id,
      organization_id,
      question_id,
      keyword,
      starting_after,
      limit,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data;
}

export async function updateEsgComplianceKpiLinkage({
  esg_compliance_id,
  metric_id,
  parent_id,
  kpi_id,
  action,
}) {
  const data = await apiBolerplate({
    url: "/esg_compliance/kpi_linkage",
    bodyData: {
      esg_compliance_id,
      metric_id,
      parent_id,
      kpi_id,
      action,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data; // Return the data for further use
}

// export async function getEsgComplianceLinkedKpi({
//   esg_compliance_id,
//   metric_id,
//   year,
// }) {
//   const data = await apiBolerplate({
//     url: "/esg_compliance/get_linked_kpis",
//     bodyData: {
//       esg_compliance_id,
//       metric_id,
//       year,
//     },
//     hideLoader: true,
//     hideMsg: true,
//   });

//   return data; // Return the data for further use
// }

// Async action creator to fetch ESG compliance report data
export const getEsgComplianceStructuredReportData = (
  esg_compliance_id,
  framework_id,
  template_type,
  starting_after,
  limit,
  keyword
) => {
  return async (dispatch) => {
    
    await apiBolerplate({
      url: "/esg_compliance_new/compliance/get_data_for_filter",
      bodyData: {
        assessment_id: esg_compliance_id,
        framework_id,
      },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        dispatch(setEsgComplianceStructuredReportData(data?.result));
      },
    });
  };
};

export const getEsgComplianceFilteredReportData = (
  esg_compliance_id,
  framework_id,
  template_type,
  starting_after,
  limit,
  keyword,
  sections,
  subsections,
  sub_subsections,
  status,
  contributors,
  approvers
) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_ESG_COMPLIANCE_FILTERED_REPORT_LOADING",
      payload: true,
    });
    await apiBolerplate({
      url: "/esg_compliance_new/compliance/get_filtered_report_data",
      bodyData: {
        esg_compliance_id,
        framework_id,
        template_type,
        starting_after,
        limit,
        keyword,
        sections,
        subsections,
        sub_subsections,
        status,
        contributors,
        approvers,
      },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        dispatch(setEsgComplianceFilteredReportData(data.filtered_results));
        dispatch({
          type: "SET_ESG_COMPLIANCE_FILTERED_REPORT_LOADING",
          payload: false,
        });
      },
    });
  };
};

export const getEsgComplianceStructuredAuditReportData = (
  esg_compliance_id,
  framework_id,
  template_type,
  starting_after,
  limit,
  keyword
) => {
  return async (dispatch) => {
    await apiBolerplate({
      url: "/esg_compliance/get_structured_audit_report_data",
      bodyData: {
        esg_compliance_id,
        framework_id,
        template_type,
        starting_after,
        limit,
        keyword,
      },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        dispatch(setEsgComplianceStructuredAuditReportData(data));
      },
    });
  };
};

export const getEsgComplianceFilteredAuditReportData = (
  esg_compliance_id,
  framework_id,
  template_type,
  starting_after,
  limit,
  keyword,
  sections,
  subsections,
  sub_subsections,
  status
) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_ESG_COMPLIANCE_FILTERED_AUDIT_REPORT_LOADING",
      payload: true,
    });
    await apiBolerplate({
      url: "/esg_compliance/get_filtered_audit_report_data",
      bodyData: {
        esg_compliance_id,
        framework_id,
        template_type,
        starting_after,
        limit,
        keyword,
        sections,
        subsections,
        sub_subsections,
        status,
      },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        dispatch(
          setEsgComplianceFilteredAuditReportData(data.filtered_results)
        );
        dispatch({
          type: "SET_ESG_COMPLIANCE_FILTERED_AUDIT_REPORT_LOADING",
          payload: false,
        });
      },
    });
  };
};

export const deleteAssignedUser = ({ assignment_id }) => {
  return async (dispatch) => {
    await apiBolerplate({
      url: "esg_compliance_new/assign/unassign_user",
      bodyData: {
        assignment_id,
      },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        queryClient.invalidateQueries(["reportsData"]);
        // dispatch(
        //   setEsgComplianceFilteredAuditReportData(data.filtered_results)
        // );
      },
    });
  };
};

export const getAssignedUsers = async (assessment_id, question_id) => {
  const res = await apiBolerplate({
    url: "/esg_compliance_new/compliance/get_assigned_user_details",
    bodyData: {
      assessment_id,
      question_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return res?.result;
};

export async function getAssessmentProgress({
  framework_id,
  assessment_id,
  page,
  limit,
  search,
}) {
  const data = await apiBolerplate({
    url: "/esg_compliance_new/compliance/get_assessment_progress",
    bodyData: {
      framework_id,
      assessment_id,
      page,
      limit,
      search,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data;
}

// Get notifications list for AppBar
export async function getNotificationsList({
  filter = "all",
  limit = 20,
  skip = 0,
}) {
  const data = await apiBolerplate({
    url: "/esg_compliance_chat/get_notifications_list",
    bodyData: {
      filter,
      limit,
      skip,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data;
}

// Mark a single notification as read
export async function markNotificationAsRead({ notification_id }) {
  const data = await apiBolerplate({
    url: "/esg_compliance_chat/mark_notification_as_read",
    bodyData: {
      notification_id,
    },
    hideLoader: true,
    hideMsg: true,
  });

  return data;
}

// Mark all notifications as read
export async function markAllNotificationsAsRead() {
  const data = await apiBolerplate({
    url: "/esg_compliance_chat/mark_all_as_read",
    bodyData: {},
    hideLoader: true,
    hideMsg: false, // Show success message
  });

  return data;
}

// ----------------- XBRL Import -----------------

/**
 * Import XBRL file data to database
 *
 * @param {File} file - XBRL XML file
 * @param {string} assessment_id - Assessment ID
 * @param {string} framework_id - Framework ID
 * @param {string} organization_id - Organization ID
 * @returns {Promise<Object>} Import result with success/failed/not_found counts
 */
export async function importXBRLToDatabase(file, assessment_id, framework_id, organization_id) {
  const data = await apiBolerplate({
    url: "/xbrl/import/import-to-database",
    method: "POST",
    bodyData: { assessment_id, framework_id, organization_id },
    files: { file },
    hideLoader: false,
    hideMsg: false,
    messageType: "success",
  });

  return data;
}
